import TransitApi from './base'

export default {
  async login(email, password) {
    try {
      const Api = TransitApi.getInstance()
      const result = await Api.post('/auth/login', {
        email,
        password,
      })
      return result
    } catch (error) {
      return error.response
    }
  },
}
